const videoSource3 = [
  {
    id: "video5",
    src: require("./1_5.mp4"),
  },
];

export default videoSource3;
